/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil, exhaustMap, tap, mapTo } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import {
    CashBoxStateTabAction,
    CashBoxStateTabActionType,
    fetchCashBoxStateHistorySuccessAction,
    fetchCashBoxStateHistoryErrorAction,
    downloadStateHistorySuccessAction,
    downloadStateHistoryErrorAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxStateTabActions';
import { downloadDataAsFile, parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';

export const fetchCashBoxStateHistoryEpic: Epic<CashBoxStateTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxStateTabActionType.FETCH_CASHBOX_STATE_HISTORY),
        switchMap((action) => {
            const params = action.payload;
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const listName = i18n.t('RegistryScreens.cashBoxStateHistory').toLowerCase();

            return from(cashboxesClient.getCashBoxStateHistory(taxNumber, params)).pipe(
                map((resp) => {
                    return fetchCashBoxStateHistorySuccessAction(resp);
                }),
                catchError((err: AxiosError) =>
                    of(
                        fetchCashBoxStateHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(CashBoxStateTabActionType.EXIT_CASHBOX_STATE_TAB)),
            );
        }),
    );
};

export const cashBoxStateHistoryDownloadEpic: Epic<CashBoxStateTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxStateTabActionType.DOWNLOAD_STATE_HISTORY),
        exhaustMap((action) => {
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const fileName = `cashbox_${taxNumber}_ModeHistory.xls`;

            return from(cashboxesClient.downloadCashBoxStateHistoryAsExcel(taxNumber, action.payload)).pipe(
                tap((fileData) => downloadDataAsFile(fileName, fileData)),
                mapTo(downloadStateHistorySuccessAction()),
                catchError((err: AxiosError) =>
                    of(
                        downloadStateHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedUploadFileName', { fileName })),
                        ),
                    ),
                ),
            );
        }),
    );
};
